'use strict';

var fetch = require('isomorphic-fetch');
var store = require('./store.js');

const CLEAR_STATE = 'CLEAR_STATE';
const REQUEST_DATA = 'REQUEST_DATA';
const RECEIVE_DATA = 'RECEIVE_DATA';
const FETCH_ERROR = 'FETCH_ERROR';
const SET_REDIRECT_URL = 'SET_REDIRECT_URL'; // change? maybe just a generic "set" function?
const SET_SESSION_TOKEN = 'SET_SESSION_TOKEN'; // change? maybe just a generic "set" function?
const SET_ALERT = 'SET_ALERT';
const SET_LANGUAGE = 'SET_LANGUAGE';
const CLEAR_ALERT = 'CLEAR_ALERT';
const CLEAR_STATE_BLOCK = 'CLEAR_STATE_BLOCK';
const INVALIDATE_STATE_BLOCKS = 'INVALIDATE_STATE_BLOCKS';
const SET_DATA = 'SET_DATA';
const SET_STATE_BLOCK = 'SET_STATE_BLOCK';

/* Example: http://redux.js.org/docs/advanced/ExampleRedditAPI.html */
function fetchDataIfReady(api_token, block, method, endpoint, body, extra_headers, force_fetch, merge_data, success_alert, set_data, merge_partial, merge_partial_key, clearStateBlock) {
  api_token = (typeof api_token !== 'undefined') ? api_token : null; // maybe add a "var checker"/"is set" function?
  body = (typeof body !== 'undefined') ? body : undefined; // NOTE: this way `yarn build`/`npm run-script build` wont fail to minify/compile.
  extra_headers = (typeof extra_headers !== 'undefined') ? extra_headers : null;
  force_fetch = (typeof force_fetch !== 'undefined') ? force_fetch : false;
  merge_data = (typeof merge_data !== 'undefined') ? merge_data : false;
  success_alert = (typeof success_alert !== 'undefined') ? success_alert : false;
  set_data = (typeof set_data !== 'undefined') ? set_data : false;
  merge_partial = (typeof merge_partial !== 'undefined') ? merge_partial : false;
  merge_partial_key = (typeof merge_partial_key !== 'undefined') ? merge_partial_key : null;
  clearStateBlock = (typeof clearStateBlock !== 'undefined') ? clearStateBlock : null;

  return function(dispatch, getState) {
    if(force_fetch || shouldFetchData(store.default.getState(), block, merge_data, merge_partial)) {
      dispatch(fetchData(api_token, block, method, endpoint, body, extra_headers, merge_data, success_alert, set_data, merge_partial, merge_partial_key, clearStateBlock));
    }
  }
}

function shouldFetchData(state, block, merge_data, merge_partial) {
  const object_block = state.apiData[block];
  return (object_block === undefined || (!object_block.isValid && !object_block.isFetching) || (merge_data && !object_block.isFetching) || (merge_partial && !object_block.isFetching));
}

function fetchDataIfUndefined(api_token, block, method, endpoint, body, extra_headers) {
  body = (typeof body !== 'undefined') ? body : undefined;
  extra_headers = (typeof extra_headers !== 'undefined') ? extra_headers : null;

  return function(dispatch, getState) {
    const object_block = store.default.getState().apiData[block];
    if(object_block === undefined) {
      dispatch(fetchData(api_token, block, method, endpoint, body, extra_headers, false, false));
    }
  }
}

function fetchData(api_token, block, method, endpoint, body, extra_headers, merge_data, success_alert, set_data, merge_partial, merge_partial_key, clearStateBlock) {
  return function(dispatch) {
    dispatch(requestData(block));
    var headers = {
      'Authorization': 'token '+api_token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    if(extra_headers) {
      Object.assign(headers, extra_headers);
    }

    return fetch(endpoint, {
      method: method,
      headers: headers,
      body: body
    })
    .then(function(response) {
      if(response.status >= 400 && response.status < 500) {
        if(response.status !== 403 && response.status !== 422) {
          return response.json().then(function(json) {
            return {status: response.status, msg: "Client error: \""+json.message+"\""};
          });
        } else {
          return response.json().then(function(json) {
            return {status: response.status, msg: json.message};
          });
        }
      } else if(response.status >= 500) {
        return response.json().then(function(json) {
          return {status: response.status, msg: "Server error: \""+json.message+"\""};
        });
      } else {
        return response.json().then(function(json) {
          return {status: response.status, json: json, page: response.headers.get('PM-List-Page'), pagesize: response.headers.get('PM-List-Pagesize')};
        });
      }
    })
    .then(
      function(response_filtered) {
        if(response_filtered.status >= 400) {
          dispatch({type:FETCH_ERROR, block:block, status:response_filtered.status, message:response_filtered.msg, error_type:"api"})
        } else {
          if(success_alert) {
            dispatch({type:FETCH_ERROR, message:response_filtered.json.message, error_type:"success"}) // maybe change names, success isn't really an error
          }
          dispatch(receiveData(block, response_filtered.json, merge_data, response_filtered.page, response_filtered.pagesize, merge_partial, merge_partial_key))
          if(set_data) {
            dispatch({type:SET_DATA, target_block:set_data, data:response_filtered.json.data, page:response_filtered.page, pagesize:response_filtered.pagesize})
          }
          if(clearStateBlock) {
            dispatch({type:CLEAR_STATE_BLOCK, block:clearStateBlock})
          }
        }
      },
      function(err) {
        // Error WHILE fetching
        dispatch({type:FETCH_ERROR, block:block, message:""+err, error_type:"local"})
        // this is also thrown if the database or the API is offline/unreachable
        // @TODO_WHN this one is rather important, notification/monitor or something?
      }
    );
  }
}

function requestData(block) {
  return {type: REQUEST_DATA, block: block};
}

function receiveData(block, data, merge_data, page, pagesize, merge_partial, merge_partial_key) {
  return {type: RECEIVE_DATA, block: block, data: data, merge_data: merge_data, page: page, pagesize: pagesize, merge_partial: merge_partial, merge_partial_key: merge_partial_key};
}

function setRedirectUrl(data) {
  return {type: SET_REDIRECT_URL, data: data};
}

function setSessionToken(data) {
  return {type: SET_SESSION_TOKEN, data: data};
}

function setAlert(message, msgtype) {
  msgtype = (typeof msgtype !== 'undefined') ? msgtype : "";
  return {type: SET_ALERT, message:message, msgtype:msgtype}
}

function setLanguage(new_lang) {
  return {type: SET_LANGUAGE, new_language:new_lang}
}

function clearAlert() {
  return {type: CLEAR_ALERT};
}

function clearStateBlock(block) {
  return {type: CLEAR_STATE_BLOCK, block: block}
}

function invalidateStateBlocks(blocks) {
  return {type: INVALIDATE_STATE_BLOCKS, blocks: blocks}
}

function clearState() {
  return {type: CLEAR_STATE};
}

function setStateBlock(block, data) {
  return {type: SET_STATE_BLOCK, block: block, data: data};
}


module.exports = {
  fetchDataIfReady: fetchDataIfReady,
  fetchDataIfUndefined: fetchDataIfUndefined,
  setRedirectUrl: setRedirectUrl,
  setSessionToken: setSessionToken,
  setAlert: setAlert,
  setLanguage: setLanguage,
  clearAlert: clearAlert,
  clearStateBlock: clearStateBlock,
  invalidateStateBlocks: invalidateStateBlocks,
  clearState: clearState,
  setStateBlock: setStateBlock
}



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/fetch.action.js
// module id = 170
// module chunks = 0